import { useEffect, useRef, useState } from 'react';
import { TableList } from 'seagull';
import { scrollIntoView } from "../../../infra/utils";
import { Mode } from "./ServicePicker.utils";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ServicePickerRow(_ref) {
  let {
    isNew,
    service,
    items,
    mode,
    onSelectionChange
  } = _ref;
  const rowRef = useRef(null);
  const [addPulse, setAddPulse] = useState(false);
  useEffect(() => {
    if (isNew) {
      // cypress version 12.11 can't handle a smooth behavior. Please remove this ugly hack whenn upgrading cypress
      rowRef.current && scrollIntoView(rowRef.current, {
        block: 'end',
        disableScrollAnimation: IS_CYPRESS
      });
      setTimeout(() => setAddPulse(true), 300); // Pulse should start after scroll animation ends.
    } else {
      setAddPulse(false);
    }
  }, [isNew]);
  return /*#__PURE__*/_jsx(TableList.Row, {
    ref: rowRef,
    as: "button",
    size: mode === Mode.Bundles ? 'fluid' : 'medium',
    onClick: onSelectionChange != null ? () => onSelectionChange() : () => null,
    rowId: service.id,
    addPulse: addPulse,
    "data-testid": "uneditable-service-picker-row",
    "data-name": service.name,
    items: items
  });
}